import { CustomRouteWaypoint } from '../types/CustomRoute';

export const stubbedCustomRouteWaypoint: CustomRouteWaypoint = {
  id: 0,
  name: 'test waypoint',
  latitude: 0,
  longitude: 0,
  showTitle: false
};
